(function(angular) {
	'use strict';
	/**
	 * navigation module
	 */
	var navigation = angular.module('Core');

	/*
	 * Used to enable / disable elements when navigation is enabled / disabled
	 * In fact add a class (nav-disabled) to the element when disabled.
	 */
	navigation.directive('navStateAware', ['$rootScope',
		function($rootScope) {
			return {
				scope: false,
				restrict: 'A',
				link: function(scope, element, attrs) {
					scope.navEnabled = true;
					$rootScope.$on('navigation-enabled', function(event, enabled) {
						scope.navEnabled = enabled;
						if (!enabled) {
							$(element).addClass('nav-disabled');
							$(element).attr('disabled', 'disabled');
						} else {
							$(element).removeClass('nav-disabled');
							$(element).removeAttr('disabled');
						}
					});
				}
			};
		}]);

	/*
	 * Used to enable / disable elements when navigation is enabled / disabled
	 * In fact add a class (nav-disabled) to the element when disabled.
	 */
	navigation.directive('navStateDisabled', ['$rootScope', '$log',
		function($rootScope, $log) {
			return {
				scope: false,
				restrict: 'A',
				link: function(scope, element, attrs) {
					scope.navEnabled = true;

					var links = $(element);
					links.click('click', function(e) {
						if (!scope.navEnabled) {
							e.preventDefault();
							$log.debug('navStateDisabled: Navigation is disabled. Link event prevented.');
						}
					});

					$rootScope.$on('navigation-enabled', function(event, enabled) {
						scope.navEnabled = enabled;
						if (!enabled) {
							$(element).addClass('nav-disabled');
							$(element).attr('disabled', 'disabled');
						} else {
							$(element).removeClass('nav-disabled');
							$(element).removeAttr('disabled');
						}
					});
				}
			};
		}]);

	/*
	 * Used to disable all links when present and the nav is disabled
	 */
	navigation.directive('mainTabs', ['$rootScope', '$location', '$timeout', '$log', 'NavigationService',
		function($rootScope, $location, $timeout, $log, NavigationService) {
			return {
				priority: 1000,
				scope: false,
				restrict: 'E',
				replace: true,
				transclude: true,
				templateUrl: 'components/core/navigation/navigation-tabs.html',
				controller: ['$scope', function($scope) {
						$scope.tabs = [];

						$scope.navEnabled = true;

						var hidden = false;


						/*
						 * Search a tab by his id
						 * @param {int} id Used to identify the tab
						 * @returns: the tab that match the url or null if the tab is not found
						 */
						var searchTabById = function(id) {
							var tabs = $scope.tabs;
							for (var i = 0; i < tabs.length; i++) {
								var tab = tabs[i];
								if (tab.tabId === id) {
									return tab;
								}
							}
							return null;
						};
						var loadTabs = function() {
							if (hidden === false) {
								$scope.tabs = NavigationService.getTabs();
							} else {
								$scope.tabs = [];
							}
						};
						/*
						 * Change the currently displayed tab
						 */
						var activateTab = function(tab) {
							if (NavigationService.isNavigationEnabled()) {
								$timeout(function() {
									$location.path(tab.tabUrl);
								}, 0);
							}
						};


						$scope.activate = function(tabId) {
							var tab = searchTabById(tabId);
							if (tab !== null) {
								activateTab(tab);
							}
						};

						$scope.close = function(tabId) {
							NavigationService.closeTab(tabId);
						};

						// EVENT HANDLING
						$rootScope.$on('navigation-update', function() {
							loadTabs();
						});
						$rootScope.$on('navigation-enabled', function(event, enabled) {
							$scope.navEnabled = enabled;
						});
						$rootScope.$on('navigation-hidden', function() {
							hidden = true;
							loadTabs();
						});



						loadTabs();
					}]
			};
		}]);
})(angular);